import bar1 from "../assets/bar1.jpeg";
import bar2 from "../assets/bar2.jpeg";
import bar3 from "../assets/bar3.jpeg";
import bar4 from "../assets/bar4.jpeg";
import drc1 from "../assets/drc1.jpeg";
import drc4 from "../assets/drc4.jpeg";
import drc6 from "../assets/drc6.jpeg";
import drc7 from "../assets/drc7.jpeg";
import fire1 from "../assets/fire1.jpeg";
import fire2 from "../assets/fire2.jpeg";
import fire3 from "../assets/fire3.jpeg";
import fire4 from "../assets/fire4.jpeg";
import fires1 from "../assets/fires1.jpeg";
import fires2 from "../assets/fires2.jpeg";
import fires3 from "../assets/fires3.jpeg";
import fires4 from "../assets/fires4.jpeg";
import line1 from "../assets/line1.jpeg";
import line2 from "../assets/line2.jpeg";
import line3 from "../assets/line3.jpeg";
import line4 from "../assets/line4.jpeg";
import material1 from "../assets/material1.jpeg";
import material2 from "../assets/material2.jpeg";
import material3 from "../assets/material3.jpeg";
import material4 from "../assets/material4.jpeg";

export const projects = [
  {
    id: 1,
    title: "Fire Protection System Upgrade",
    category: "Fire Protection",
    img: fire2,
    images: [fire3, fire1, fire4, fire2],
    description:
      "This project involved upgrading the existing fire protection system at KIOTA Youth Hostel to meet modern safety standards. The work included replacing outdated fire extinguishers, installing new smoke detectors and fire alarms, upgrading fire hose reel systems, adding emergency signage, and improving evacuation routes. Our team also conducted system testing, safety inspections, and staff training to ensure full operational readiness and compliance.",
    client: "KIOTA Youth Hostel",
    dateStarted: "Mar 2023",
    dateCompleted: "Apr 2023",
  },
  {
    id: 2,
    title: "DRC Renovation",
    category: "Design & Construction",
    img: drc6,
    images: [drc6, drc7, drc1, drc4],
    description:
      "This project focused on transforming the existing space through a complete renovation. The work included redesigning the layout, enhancing structural elements, improving lighting, upgrading flooring and wall finishes, and installing modern interior features. The outcome is a refreshed, functional, and aesthetically pleasing environment tailored to the client’s needs.",
    client: "Class Villa",
    dateStarted: "July 2024",
    dateCompleted: "Aug 2024",
  },
  {
    id: 3,
    title: "Fire Safety System",
    category: "Fire Safety Solutions",
    img: fires1,
    images: [fires1, fires2, fires3, fires4],
    description:
      "This project involved supplying, installing, and commissioning a complete fire safety system for Sharaff Shipping Agency. The scope included the provision of certified fire extinguishers, installation of fire hose reels, smoke detectors, fire alarms, safety signage, and emergency exit systems. Our team carried out full site inspection, safety planning, placement of equipment according to standards, and staff training on proper fire response procedures. The result is a fully equipped and compliant fire safety environment that enhances protection for both personnel and property.",
    client: "Sharaff Shipping Agency",
    dateStarted: "May 2022",
    dateCompleted: "July 2022",
  },
  {
    id: 4,
    title: "Car Park Line Marking",
    category: "Construction",
    img: line1,
    images: [line1, line2, line3, line4],
    description:
      "This project involved designing and marking a full parking area to improve traffic organization and safety. The work included planning the parking layout, preparing the surface, and applying high-quality reflective road-marking paint. The result is a clearly structured and safe parking environment that enhances user experience and supports efficient vehicle movement.",
    client: "Benjamin Mkapa Foundation",
    dateStarted: "May 2024",
    dateCompleted: "July 2024",
  },
  {
    id: 5,
    title: "Lounge Design and construction",
    category: "Design & Construction",
    img: bar1,
    images: [bar1, bar2, bar3, bar4],
    description:
      "“This project covered the complete design and construction of a modern pub and lounge. Our team developed the interior concept, designed the bar layout, selected materials and finishes, and created detailed 3D visuals for client approval. After design approval, we executed the full construction process, including structural work, custom bar installation, lighting setup and  furniture fabrication.",
    client: "Dallab Pub & Lounge",
    dateStarted: "July 2021",
    dateCompleted: "Oct 2021",
  },
  {
    id: 6,
    title: "Building material Supply",
    category: "Material Supply",
    img: material1,
    images: [material1, material2, material3, material4],
    description:
      "Upgrading the electrical systems of an industrial facility to ensure safety and compliance with standards.",
    client: "PowerTech Industries",
    dateStarted: "Jul 2022",
    dateCompleted: "Dec 2022",
  },
];
